var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEditing(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "edit-2",
    clipPath: "url(#clip0_8427_85668)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.0417 2.12489C12.2277 1.93885 12.4486 1.79127 12.6917 1.69059C12.9347 1.58991 13.1953 1.53809 13.4584 1.53809C13.7215 1.53809 13.982 1.58991 14.225 1.69059C14.4681 1.79127 14.689 1.93885 14.875 2.12489C15.0611 2.31093 15.2086 2.53179 15.3093 2.77486C15.41 3.01793 15.4618 3.27846 15.4618 3.54156C15.4618 3.80465 15.41 4.06518 15.3093 4.30825C15.2086 4.55132 15.0611 4.77218 14.875 4.95822L5.31252 14.5207L1.41669 15.5832L2.47919 11.6874L12.0417 2.12489Z",
    stroke: "#76736F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8427_85668"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 17,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditing);
export default __webpack_public_path__ + "static/media/editing.1600d9a4fc1c662e38a9c0503d61c4f7.svg";
export { ForwardRef as ReactComponent };